module.exports = __webpack_public_path__ + "static/media/left-easy.30732163.svg";